import {
  FETCH_PARENT_CATEGORY,
  FETCH_VARIANT,
  FETCH_ALL_CATEGORY,
  FETCH_CHILD_CATEGORY,
  FETCH_BRAND,
  FETCH_BRAND_BY_CATEGORY,
  FETCH_FEATURE_LIST,
  CREATE_BRAND,
  ADD_PRODUCT,
  ADD_VARIANT_NAME,
  FETCH_PRODUCT_BY_ID,
  FETCH_VARIANT_IMGS,
  FETCHING_ALL_CATEGORY,
  SELECTED_VARIANT,
  FETCH_VARIANT_V2,
  FETCH_FEATURE_VARIANT_LIST,
  RESET_ADD_PRODUCT_FLOW,
} from "../Constants/types";

const initialState = {
  Parent_Categories: [],
  All_Categories: [],
  Child_Categories: [],
  Brands: [],
  Specifications: [],
  NewBrands: [],
  VariantFeatureName: [],
  AddedProduct: {},
  ProductVariantNameObj: {},
  FetchedProductById: {},
  VariantImgs: [],
  isAllCategoryLoading: false,
  SelectedVariant: {},
  VariantIds: {},
  fetchVariant_pid: [],
  fetch_variant_list: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_PARENT_CATEGORY:
      return {
        ...state,
        Parent_Categories: action.payload,
      };
    case FETCH_ALL_CATEGORY:
      // console.log(action);
      return {
        ...state,
        All_Categories: action.payload,
        isAllCategoryLoading: false,
      };
    case FETCH_CHILD_CATEGORY:
      // console.log(action);
      return {
        ...state,
        Child_Categories: action.payload,
      };
    case FETCH_BRAND:
      // console.log(action);
      return {
        ...state,
        Brands: action.payload,
      };
    case FETCH_BRAND_BY_CATEGORY:
      // console.log(action);
      return {
        ...state,
        Brands: action.payload,
      };
    case FETCH_FEATURE_LIST:
      console.log(action);
      return {
        ...state,
        Specifications: action.payload,
      };
    case CREATE_BRAND:
      return {
        ...state,
        NewBrands: action.payload,
      };
    case FETCH_VARIANT:
      return {
        ...state,
        VariantFeatureName: action.payload,
      };
    case ADD_PRODUCT:
      return {
        ...state,
        AddedProduct: action.payload,
      };
    case ADD_VARIANT_NAME:
      return {
        ...state,
        ProductVariantNameObj: action.payload,
      };
    case FETCH_PRODUCT_BY_ID:
      return {
        ...state,
        FetchedProductById: action.payload,
      };
    case FETCH_VARIANT_IMGS:
      return {
        ...state,
        VariantImgs: action.payload,
      };
    case FETCHING_ALL_CATEGORY:
      return {
        ...state,
        isAllCategoryLoading: action.payload,
      };
    case SELECTED_VARIANT:
      return {
        ...state,
        SelectedVariant: action.payload.SelectedVariant,
        VariantIds: action.payload.variantIds, // This is a new property to store variant IDs for selected variant
      };
    case FETCH_VARIANT_V2:
      return {
        ...state,
        fetchVariant_pid: action.payload,
      };

    case FETCH_FEATURE_VARIANT_LIST:
      return {
        ...state,
        fetch_variant_list: action.payload,
      };

    // Starting a new product must not reuse the previous product's data.
    case RESET_ADD_PRODUCT_FLOW:
      return {
        ...state,
        Brands: [],
        Specifications: [],
        AddedProduct: {},
        ProductVariantNameObj: {},
        FetchedProductById: {},
        VariantImgs: [],
        SelectedVariant: {},
        VariantIds: {},
        fetchVariant_pid: [],
        fetch_variant_list: {},
      };

    default:
      return state;
  }
}
